// 移动端适配
function adapt(designWidth, rem2px,maxWidth) {

	var d = window.document.createElement('div');

	d.style.width = '1rem';

	d.style.display = "none";

	var head = window.document.getElementsByTagName('head')[0];

	head.appendChild(d);

	var defaultFontSize = parseFloat(window.getComputedStyle(d, null).getPropertyValue('width'));

	head.removeChild(d);

	var fontsize = window.innerWidth / designWidth * rem2px + 'px';

//	var defaultSize = maxWidth && maxWidth/designWidth*rem2px;
//		if(parseInt(fontsize) > defaultSize){
//			fontsize = defaultSize;
//		};
	if(parseInt(fontsize) > 14){
		fontsize = 14+'px';
	}
	document.documentElement.style.fontSize = fontsize;

	var st = document.createElement('style');

	var portrait = "@media screen and (min-width: " + window.innerWidth + "px) {html{font-size:" + ((window.innerWidth / (designWidth / rem2px))) + "px;}}";

	var landscape = "@media screen and (min-width: " + window.innerHeight + "px) {html{font-size:" + ((window.innerHeight / (designWidth / rem2px))) + "px;}}"

	st.innerHTML = portrait + landscape;

	head.appendChild(st);

	return defaultFontSize

};

var defaultFontSize = adapt(375, 10);
window.onresize = function(){
    	adapt(375, 10);
}



// WEBPACK FOOTER //
// ./src/util/rem.js